// s_code.js needs to be loaded before this script
// s_account is localized and defined in s_code.js
var shareCart = function (s_account) {
	'use strict';
	
	var jsMessages,
	form = new forms4i(),
	
	init = function(){
		if(!document.getElementById("divHotScroller")){ // not empty cart
			// remove shared cart query string to prevent recreating cart
			var url = document.getElementById("hfUrl").value;
			if (url && url.trim().length > 0) {
				document.getElementById("shareCartForm") && document.getElementById("shareCartForm").setAttribute("action", url);
				window.history.replaceState({}, document.title, url);
			}
		
			var shareRadios = document.getElementById("sharePopup") ? [].slice.call(document.getElementById("sharePopup").querySelectorAll("input[name='shareMethod']")) : null;
			shareRadios && shareRadios.forEach(function(el, index, array){
				el.addEventListener("change", function () {
					formEvents.UpdateRadioGroup(el);
				});
			});
			
			document.getElementById("sharePopup") && document.getElementById("sharePopup").getElementsByClassName("sendCart")[0].addEventListener("click", function (e) {
				e.preventDefault();
				omniture.SendBtnClick();
				form.formValidation(document.getElementById("shareCartForm"), formEvents.FormIsValid, e);
			});
		}
	},
	
	formEvents = (function () {
		var updateRadioGroup = function (radio) {
			if(document.getElementById("ErrorBox")){
				document.getElementById("ErrorBox").parentNode.removeChild(document.getElementById("ErrorBox"));
			}
			document.getElementById("sharedCartError").textContent = "";

			if (radio.value === "sms" && radio.checked) {
				document.getElementById("emailInputShow").classList.add("hide");
				document.getElementById("emailInput").classList.remove("txtReq");
				
				document.getElementById("emailReply").classList.add("hide");
				document.getElementById("fromEmailInput").classList.remove("txtReq");
				
				document.getElementById("phoneInputShow").classList.remove("hide");
				document.getElementById("smsInput").classList.add("txtReq");
				
				document.getElementById("phoneReply").classList.remove("hide");
				document.getElementById("fromSmsInput").classList.add("txtReq");
				
				document.getElementById("emailInput").value = ""; 
				document.getElementById("fromEmailInput").value = ""; 
				document.getElementById("emailInput").classList.remove("input-validation-error");
				document.getElementById("fromEmailInput").classList.remove("input-validation-error");
				document.getElementById("emailInput").setAttribute("aria-invalid", "false");
				document.getElementById("fromEmailInput").setAttribute("aria-invalid", "false");
				document.getElementById("emailInput").nextElementSibling.nextElementSibling.classList.add('hide');
				document.getElementById("fromEmailInput").nextElementSibling.nextElementSibling.classList.add('hide');
				
			} else {
				document.getElementById("emailInputShow").classList.remove("hide");
				document.getElementById("emailInput").classList.add("txtReq");
				
				document.getElementById("emailReply").classList.remove("hide");
				document.getElementById("fromEmailInput").classList.add("txtReq");
				
				document.getElementById("phoneInputShow").classList.add("hide");
				document.getElementById("smsInput").classList.remove("txtReq");
				
				document.getElementById("phoneReply").classList.add("hide");
				document.getElementById("fromSmsInput").classList.remove("txtReq");
				
				document.getElementById("smsInput").value = ""; 
				document.getElementById("fromSmsInput").value = ""; 
				document.getElementById("smsInput").classList.remove("input-validation-error");
				document.getElementById("fromSmsInput").classList.remove("input-validation-error");
				document.getElementById("smsInput").setAttribute("aria-invalid", "false");
				document.getElementById("fromSmsInput").setAttribute("aria-invalid", "false");
				document.getElementById("smsInput").nextElementSibling.nextElementSibling.classList.add('hide');
				document.getElementById("fromSmsInput").nextElementSibling.nextElementSibling.classList.add('hide');
			}
		},
		showAjaxMessage = function (msg) {
			document.getElementById("sharedCartError").innerHTML = msg;
		},
		hideAjaxMessage = function () {
			document.getElementById("sharedCartError").textContent = "";
		},
		showBusy = function () {
			document.getElementById("sharePopup").getElementsByClassName("sendCart")[0].setAttribute("disabled", "disabled");
			document.getElementById("loadSummaryBox").classList.remove("hide");
		},
		hideBusy = function () {
			document.getElementById("sharePopup").getElementsByClassName("sendCart")[0].removeAttribute("disabled");
			document.getElementById("loadSummaryBox").classList.add("hide");
		},
		formIsValid = function(){
			var shareRadios = [].slice.call(document.getElementById("sharePopup").querySelectorAll("input[name='shareMethod']"));
			shareRadios.forEach(function(el, index, array){
				if(el.checked && el.value === "email"){
					ajaxActions.SendEmail();
				}else if(el.checked && el.value === "sms"){
					ajaxActions.SendSMS();
				}
			});
		};
		
		return {
			UpdateRadioGroup: updateRadioGroup,
			ShowAjaxMessage: showAjaxMessage,
			HideAjaxMessage: hideAjaxMessage,
			ShowBusy: showBusy,
			HideBusy: hideBusy,
			FormIsValid: formIsValid
		};
	}()),
	
	ajaxActions = (function () {
		var antiForgeryToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? { "__RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value } : "",
		headerToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "",
		cartId = document.getElementById("UserCart_CartID") ? document.getElementById("UserCart_CartID").value : "",
		guirId = document.getElementById("UserCart_GURID") ? document.getElementById("UserCart_GURID").value : "",

		getMessages = function () {
			var getMsg = ajax({
				url: '/cart/javascriptMessages/sharecart',
				method: 'GET'
			});
			getMsg.then(function(response, xhr){
				jsMessages = response;
			});
			getMsg.catch(function(response, xhr){
				return null;
			});
		},
		sendEmail = function () {
			formEvents.ShowBusy();
			var emailShared = ajax({
				url: '/cart/emailshared',
				method: 'POST',
				data: { cartid: cartId, gurid: guirId, email: document.getElementById("emailInput").value, fromemail: document.getElementById("fromEmailInput").value, comment: document.getElementById("shareCartComments").value },
				headers: antiForgeryToken
			});
			emailShared.then(function(response, xhr){
				var msg;
				if (response.success) {
					msg = jsMessages.emailSent;
				} else {
					msg = jsMessages.emailFailed;
				}

				formEvents.ShowAjaxMessage(msg);
				formEvents.HideBusy();
				document.getElementById("shareCartTab").focus();
			});
			emailShared.catch(function(response, xhr){
				formEvents.ShowAjaxMessage(jsMessages.emailFailed);
				formEvents.HideBusy();
				document.getElementById("emailInput").focus();
			});
		},
		sendSMS = function () {
			formEvents.ShowBusy();
			fetch('sms/sendsharecart', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify({ cartid: cartId, gurid: guirId, phone: document.getElementById("smsInput").value, fromphone: document.getElementById("fromSmsInput").value, comment: document.getElementById("shareCartComments").value }), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'__RequestVerificationToken': headerToken
	        		}
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				var msg;
				if (response.success) {
					msg = jsMessages.textSent;
				} else {
					msg = jsMessages.textFailed;
				}
				formEvents.ShowAjaxMessage(msg);
				formEvents.HideBusy();
				document.getElementById("shareCartTab").focus();
			}).catch(function(error){
				formEvents.ShowAjaxMessage(jsMessages.textFailed);
				formEvents.HideBusy();
				document.getElementById("smsInput").focus();
			});
		};
		
		getMessages();

		return {
			SendEmail: sendEmail,
			SendSMS: sendSMS
		};
	}()),

	omniture = (function (s_account) {
		var account = s_account ? s_account : "4imprintprod";

		var sendBtnClick = function () {
			var s = s_gi(account);
			s.linkTrackVars = 'prop21';
			s.linkTrackEvents = 'None';
			s.prop21 = "cart share";
			s.tl(true, 'o', 'Share Cart');
		};

		return {
			SendBtnClick: sendBtnClick
		};
	}(s_account));
	
	return{
		init: init
	};
};

(function(){
	var shareCartPage = new shareCart(s_account);
	shareCartPage.init();
})();